import { LinearProgress } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { Table } from 'reactstrap';
import { MomentDateFormat } from '../MomentDateFormat';
import cls from 'classnames';

export default class LowboyResourceScoreboard extends React.Component {
    getValueIfSet(value) {
        return value && value > 0 ? value : '';
    }

    render() {
        const { resourcingCounts, resourcesLoading, loading, onDateSelect } = this.props;

        if (loading || resourcesLoading) {
            return <LinearProgress variant="indeterminate" color="secondary" />;
        }

        const weekStart = moment(resourcingCounts[0].date).format(
            MomentDateFormat.MonthDayYearSlashesLeading
        );
        const weekEnd = moment(resourcingCounts[6].date).format(
            MomentDateFormat.MonthDayYearSlashesLeading
        );

        const dayLabels = ['M', 'T', 'W', 'Th', 'F', 'S', 'S'];

        return (
            <Table
                className="w-50 lowboy-resource-scoreboard"
                bordered={true}
                size="sm"
            >
                <thead>
                    <tr>
                        <th>
                            {weekStart} - {weekEnd}
                        </th>
                        {resourcingCounts.map((rc, i) => (
                            <th
                                key={`rch-${i}`}
                                onClick={() => onDateSelect && onDateSelect(rc.date)}
                                style={{ cursor: 'pointer' }}
                            >
                                {dayLabels[i]}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th>Pending</th>
                        {resourcingCounts.map((rc, i) => (
                            <td
                                key={`rcp-${i}`}
                                className={cls({
                                    'text-danger': rc.notYetDispatched > 0,
                                })}
                                onClick={() => onDateSelect && onDateSelect(rc.date)}
                                style={{ cursor: 'pointer' }}
                            >
                                {this.getValueIfSet(rc.notYetDispatched)}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <th>Dispatched</th>
                        {resourcingCounts.map((rc, i) => (
                            <td
                                key={`rcd-${i}`}
                                className={cls({
                                    'text-info': rc.dispatched > 0,
                                })}
                                onClick={() => onDateSelect && onDateSelect(rc.date)}
                                style={{ cursor: 'pointer' }}
                            >
                                {this.getValueIfSet(rc.dispatched)}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <th>Confirmed</th>
                        {resourcingCounts.map((rc, i) => (
                            <td
                                key={`rcc-${i}`}
                                className={cls({
                                    'text-success': rc.confirmed > 0,
                                })}
                                onClick={() => onDateSelect && onDateSelect(rc.date)}
                                style={{ cursor: 'pointer' }}
                            >
                                {this.getValueIfSet(rc.confirmed)}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </Table>
        );
    }
}
